import { render } from "./invCard.vue?vue&type=template&id=2850267e&scoped=true"
import script from "./invCard.vue?vue&type=script&lang=js"
export * from "./invCard.vue?vue&type=script&lang=js"

import "./invCard.vue?vue&type=style&index=0&id=2850267e&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2850267e"]])

export default __exports__